const resolveImageDomain = url => url?.replace(/[a-zA-Z]+.ctfassets.net/, 'images-cf.news12static.com')

export default resolveImageDomain
